import isNil from 'lodash/isNil';

export default class StringExpression {
    private target: string;

    public constructor(target: string) {
        this.target = target.toLowerCase().trim();
    }

    public testContains(source: string | undefined | null) {
        if (isNil(source)) {
            return false;
        }
        return sanitiseInput(source).includes(this.target);
    }

    public testNotContains(source: string | undefined | null) {
        return !this.testContains(source);
    }

    public testIsEqual(source: string | undefined | null) {
        if (isNil(source)) {
            return false;
        }
        return sanitiseInput(source) === this.target;
    }

    public testNotEqual(source: string | undefined | null) {
        return !this.testIsEqual(source);
    }

    public testStartsWith(source: string) {
        if (isNil(source)) {
            return false;
        }

        return sanitiseInput(source).startsWith(this.target);
    }

    public testEndsWith(source: string) {
        if (isNil(source)) {
            return false;
        }

        return sanitiseInput(source).endsWith(this.target);
    }
}

export function sanitiseInput(source: string | undefined | null) {
    return ('' + source).toLowerCase().trim();
}
